<template>
<div id="abstract">
    <p id="abstract_p">{{text}}</p>
</div>
</template>

<script>

export default {
  name: 'landing',
  data() {
    return {
        // text: "Forest Kindergarten is the idea that early childhood education can and should take place out in nature rather than in the confines of the traditional classroom. Studies have shown that greater exposure to nature leads to x, y, and z benefits for the students. This project aims to explore the concept and its potential benefits by looking into the history, structure, outcomes, and implementation of these programs."
        text: "Forest Kindergarten is the idea that early childhood education can and should take place out in nature rather than in the confines of the traditional classroom."
        
    }
  },
  computed: {
  },
  components: {
  },
  setup() {
  }
}
</script>

<style>
#abstract {
    width: 100%;
    margin: 0;
    height: 90%;
}

#abstract_p {
    color: white;
    font-family: Josefin;
    background-color: #839788d9;
    width: 60%;
    margin-left: auto;
    margin-right: auto;
    /*margin-top: 18%;*/
    /*margin-bottom: 20%;*/
    /*font-size: 2vw; */
    padding: 1%;
    text-align: center;
    font-size: 2.5vw; 
    margin-top: 20%;
    margin-bottom: 22.5%;
}

</style>
